// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { SendanorProductId } from "../types/SendanorProductId";
import { ProductPriceType } from "../../../../io/hyperify/core/store/types/product/ProductPriceType";

export const CURRENT_YEAR = new Date().getFullYear();
export const COMPANY_BUSINESS_ID = "3091818-9";
export const COMPANY_VAT_ID = "FI30918189";
export const COMPANY_PHONE_NUMBER_DISPLAY = "040 7300 149";
export const COMPANY_PHONE_NUMBER_FULL = "+358407300149";
export const PRIVACY_HANDLER_NAME = 'Jaakko Heusala';
export const PRIVACY_HANDLER_EMAIL = 'jhh@hg.fi';
export const PRIVACY_HANDLER_PHONE_DISPLAY = '040 7300 149';
export const PRIVACY_HANDLER_PHONE_FULL = '+358407099704';
export const COMPANY_EMAIL = 'info@palvelinkauppa.fi';
export const MAINTENANCE_PHONE_NUMBER_DISPLAY = "040 7300 149";
export const MAINTENANCE_PHONE_NUMBER_FULL = "+358407099704";
export const COMPANY_NAME = "Suomen Palvelinkauppa";
export const COMPANY_ADDRESS_LINE_1 = "Keskustori 7 A 14";
export const COMPANY_ADDRESS_LINE_2 = "33100 Tampere";
export const DESIGN_COMPANY_NAME = "Avinse Graphics";
export const DESIGN_COMPANY_WEBSITE = "https://avinse.fi";
export const IMPLEMENTATION_COMPANY_NAME = "Heusala Group Oy";
export const IMPLEMENTATION_COMPANY_WEBSITE = "https://heusalagroup.fi";
export const SENDANOR_SHELL_WEBSITE = 'https://shell.sendanor.fi/';
export const SENDANOR_SOFTWARE_WEBSITE = 'https://github.com/hyperifyio/project-govm';
export const SENDANOR_VPS_WEBSITE = 'https://vps.nor.fi/';
export const SENDANOR_PROJECT_WEBSITE = 'https://github.com/sendanor/project-sendanor.fi';
export const SENDANOR_PROJECT_TRACKER_WEBSITE = 'https://github.com/sendanor/project-sendanor.fi/issues/1';
export const SENDANOR_NOTIFICATIONS_WEBSITE = 'https://tiedotteet.sendanor.fi/';
export const SENDANOR_MAIL_WEBSITE = 'https://mail.nor.fi/';
export const COMPANY_TWITTER_NAME = 'sendanorfi';
export const COMPANY_TWITTER_URL = `https://twitter.com/${COMPANY_TWITTER_NAME}`;
export const COMPANY_FACEBOOK_URL = 'https://www.facebook.com/sendanor/';
export const COMPANY_GITHUB_URL = 'https://github.com/heusalagroup';
export const COMPANY_LINKEDIN_URL = 'https://www.linkedin.com/company/heusalagroup';
export const COMPANY_DISCORD_URL = 'https://discord.gg/dVTpkTh';
export const SENDANOR_PREMIUM_DOMAIN_WEBSITE = 'https://holvi.com/shop/sendanor/section/verkkotunnukset/';
export const SENDANOR_PHOTO_WEBSITE = 'https://holvi.com/shop/sendanor/section/kuvat/';
export const SENDANOR_WEBRTC_WEBSITE = 'https://www.2q.fi/';

export const META_PIXEL_PRIVACY_CONTENT_URL = 'https://www.facebook.com/privacy/policy/';

export const COMPANY_FOUNDING_YEAR = 2007;
export const COMPANY_ACTIVE_YEARS = new Date().getFullYear() - COMPANY_FOUNDING_YEAR;

export const PRODUCT_BUY_URL_PREFIX = (id: SendanorProductId, price: ProductPriceType) => `https://www.sendanor.fi/product/${id}/${price}`;

export const SOFTWARE_ENABLED = false;
export const DOMAINS_ENABLED = false;
export const PAYTRAIL_ENABLED = false;
